"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
type BowlerRow = {
  name: string;
  overs: string | number; // பி - overs
  maidens: string | number; // எம் - maidens
  runs: string | number; // ஆர் - runs
  wickets: string | number; // டபிள்யூ - wickets
  economy: string | number; // ஈசினன் - economy
};

// Dynamic JSON data
const BOWLING_TABLE: {
  headingLeft: string;
  columns: string[];
  bowlers: BowlerRow[];
} = {
  headingLeft: "எஸ்ஆர்ஈ பந்துவீச்சு",
  columns: ["பி", "எம்", "ஆர்", "டபிள்யூ", "ஈசினன்"],
  bowlers: [{
    name: "எம்.சிராஜ்",
    overs: "3.2",
    maidens: "-",
    runs: "-",
    wickets: "-",
    economy: "-"
  }, {
    name: "எம்.சிராஜ்",
    overs: "3",
    maidens: "-",
    runs: "-",
    wickets: "-",
    economy: "-"
  }, {
    name: "எம்.சிராஜ்",
    overs: "4",
    maidens: "-",
    runs: "-",
    wickets: "-",
    economy: "-"
  }, {
    name: "எம்.சிராஜ்",
    overs: "4",
    maidens: "-",
    runs: "-",
    wickets: "-",
    economy: "-"
  }, {
    name: "எம்.சிராஜ்",
    overs: "2",
    maidens: "-",
    runs: "-",
    wickets: "-",
    economy: "-"
  }]
};
export default function BowlerScoreTable(t0) {
  const $ = _c(4);
  const {
    className: t1
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const t2 = "w-full overflow-hidden bg-FFFFFF " + className;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="px-4 sm:px-6 py-4 bg-012061 text-FFFFFF grid grid-cols-[minmax(220px,1fr)_64px_64px_64px_64px_96px]"><div className="text-16-tamil-700 text-FFFFFF line-clamp-1">{BOWLING_TABLE.headingLeft}</div>{BOWLING_TABLE.columns.map(_temp)}</div>;
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="overflow-x-auto"><div className="min-w-[680px]">{BOWLING_TABLE.bowlers.map(_temp2)}</div></div>;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] !== t2) {
    t5 = <div className={t2}>{t3}{t4}</div>;
    $[2] = t2;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  return t5;
}
function _temp2(bowler, idx) {
  return <div key={idx} className="grid grid-cols-[minmax(220px,1fr)_64px_64px_64px_64px_96px] items-center  bg-F8F8F8 px-4 sm:px-6 h-[75px] border-t border-DCDCDC"><div className="flex flex-col justify-center"><span className="text-16-tamil-600 text-1B1B1B line-clamp-1">{bowler.name}</span></div><Cell value={bowler.overs} /><Cell value={bowler.maidens} /><Cell value={bowler.runs} /><Cell value={bowler.wickets} /><Cell value={bowler.economy} /></div>;
}
function _temp(c, i) {
  return <div key={i} className="text-center text-14-tamil-500 text-fffff line-clamp-1">{c}</div>;
}
function Cell(t0) {
  const $ = _c(2);
  const {
    value
  } = t0;
  let t1;
  if ($[0] !== value) {
    t1 = <div className="text-center text-16-english-600 text-1B1B1B leading-[1.5] line-clamp-1">{value}</div>;
    $[0] = value;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}